.ux-select__wrapper {
  display: inline-block;

  &--full-width {
    max-width: 100%;
    width: 100%;
  }

  &__inner {
    background: var(--ux-input-background-color);
  }
}
